module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sticky-legend"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Legend")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 3
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Lots of data available")])]), _vm._v(" "), _c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 2
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Some data available")])]), _vm._v(" "), _c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 1
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Little to no data available")])]), _vm._v(" "), _c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 0
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Metric does not exist for this community")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c2a2d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StickyLegend.vue
// module id = 141
// module chunks = 1